var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError504(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 273,
    viewBox: "0 0 272 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.794 135.498H134.582V124.372L133.649 109.8L135.618 102.204L137.904 105.818H179.773L188.794 135.498Z",
    fill: "#B0B6EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245.072 105.798H196.792V109.036H245.072V105.798Z",
    fill: "#23293F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.144 122.636H201.325V125.874H230.144V122.636Z",
    fill: "#23293F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8679 169.265C105.726 169.265 125.877 149.113 125.877 124.255C125.877 99.3971 105.726 79.2456 80.8679 79.2456C56.0098 79.2456 35.8584 99.3971 35.8584 124.255C35.8584 149.113 56.0098 169.265 80.8679 169.265Z",
    fill: "#B0B6EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7513 179.814C50.1772 179.814 25.3086 154.939 25.3086 124.372C25.3086 93.804 50.1836 68.929 80.7513 68.929C111.319 68.929 136.194 93.804 136.194 124.372C136.194 154.939 111.319 179.814 80.7513 179.814ZM80.7513 72.1671C51.9646 72.1671 28.5467 95.5849 28.5467 124.372C28.5467 153.158 51.9646 176.576 80.7513 176.576C109.538 176.576 132.956 153.158 132.956 124.372C132.956 95.5849 109.538 72.1671 80.7513 72.1671Z",
    fill: "#23293F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4191 147.893H85.1811V122.267H54.5811V119.029H88.4191V147.893Z",
    fill: "#F4F5F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.581 119.029H122.089V122.267H134.581V119.029Z",
    fill: "#23293F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3699 70.5481H79.1318V80.5732H82.3699V70.5481Z",
    fill: "#23293F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3699 167.024H79.1318V178.195H82.3699V167.024Z",
    fill: "#23293F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.287 119.029H26.9277V122.267H38.287V119.029Z",
    fill: "#23293F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.117 58.1592H83.8789V70.4769H87.117V58.1592Z",
    fill: "#23293F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6297 58.1592H74.3916V70.4769H77.6297V58.1592Z",
    fill: "#23293F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4004 51.5793H70.6934V54.8174H90.4004V51.5793Z",
    fill: "#23293F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M234.03 202.293H82.4873V226.255H234.03V202.293Z",
    fill: "#B0B6EE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.346 202.85H212.645L211.842 200.208L166.768 51.8904C165.686 48.3155 162.571 46.01 158.841 46.01C155.111 46.01 151.989 48.3155 150.908 51.8904L135.617 102.204C136.31 103.855 136.919 105.552 137.463 107.275L154.003 52.8294C154.806 50.1872 157.028 49.2481 158.841 49.2481C160.654 49.2481 162.869 50.1872 163.672 52.8294L179.772 105.818L180.756 109.056L187.809 132.26L188.793 135.498L208.274 199.612H130.346V202.85ZM105.833 200.208L105.03 202.85H108.534L109.298 200.208L109.466 199.612H109.402L110.71 195.319L118.093 171C116.694 172.14 115.237 173.215 113.734 174.213L105.833 200.208Z",
    fill: "#23293F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M181.961 105.818H157.222V109.056H181.961V105.818Z",
    fill: "#23293F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.108 132.26H142.741V135.498H190.108V132.26Z",
    fill: "#23293F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M233.764 200.208H130.346V203.446H232.922V222.862H207.477V226.1H233.764C235.085 226.1 236.16 225.025 236.16 223.704V202.604C236.16 201.283 235.085 200.208 233.764 200.208ZM85.9451 203.446H108.359L108.534 202.85L109.298 200.208H85.1032C83.7821 200.208 82.707 201.283 82.707 202.604V223.704C82.707 225.025 83.7821 226.1 85.1032 226.1H194.525V222.862H85.9451V203.446Z",
    fill: "#23293F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError504);
export default __webpack_public_path__ + "static/media/error504.c3cd248dbd754817ae8932c587fb3879.svg";
export { ForwardRef as ReactComponent };